module.exports = __webpack_public_path__ + "img/sillas.71eb46a1.jpg";